import axiosInstance from ".";

export const getLeads = async ({ queryKey }) => {
  const [queries] = queryKey;
  return axiosInstance.get("/leads", { params: queries });
};
export const addLeads = (data) => {
  return axiosInstance.post("/leads", data);
};

export const updateLeads = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/contact/${id}`, payload);
};
